import { CLOUD, SECONDARY_CTA, SKY, SLATE } from 'styles/Colors';
import { Desktop } from 'styles/MediaQueries';

const linkButtonStyles = {
  textDecoration: 'underline',
  marginTop: '1rem',
  width: '100%',
  textAlign: 'center',
  padding: '0 0 1rem 0'
};

const loginContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem'
};

const forgotLinkButtonStyles = {
  ...linkButtonStyles,
  marginTop: '0',
  textAlign: 'left'
};

const loginNoticeStyles = {
  fontStyle: 'italic',
  fontSize: '0.875rem',
  color: SLATE,
  margin: '1rem 0 1rem 0',
  textAlign: 'justify'
};

const buttonStyles = {
  color: SKY,
  marginTop: '1rem',
  background: CLOUD,
  display: 'flex',
  justifyContent: 'center',
  gap: '0.5rem',
  alignItems: 'center'
};

const ctaContainerStyles = {
  [Desktop]: {
    maxWidth: '27rem',
    margin: 'auto'
  }
};

const loginButtonStyles = {
  background: SECONDARY_CTA,
  color: 'black'
};

const buttonContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  button: {
    height: '3rem',
    width: '100%'
  }
};

export {
  linkButtonStyles,
  loginButtonStyles,
  loginContainerStyles,
  loginNoticeStyles,
  forgotLinkButtonStyles,
  buttonStyles,
  ctaContainerStyles,
  buttonContainerStyles
};
